<template>
  <!-- eslint-disable max-len -->
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 1381.9 134.6"
    style="enable-background:new 0 0 1381.9 134.6;"
    xml:space="preserve"
    :class="[
      isWhite ? 'logo--is-white' : '',
    ]"
  >
    <title>{{ $t('Port of Amsterdam') }}</title>
    <g>
      <g>
        <path class="logo__logo" d="M101.2,0l-30,30c17.6,1.9,31.5,15.8,33.4,33.4l30-30L101.2,0L101.2,0z" />
        <path class="logo__logo" d="M0,33.4l30,30C31.8,45.7,45.7,31.8,63.3,30l-30-30L0,33.4z" />
        <path class="logo__logo" d="M71.2,104.6l30,30l33.4-33.4l-30-30C102.7,88.8,88.8,102.7,71.2,104.6z" />
        <path class="logo__logo" d="M30,71.2l-30,30l0,0l33.4,33.4l0,0l30-30C45.7,102.7,31.8,88.8,30,71.2z" />
      </g>
      <g>
        <path class="svg--no-background"
              d="M551.5,63.4c-5.3,0-9.4,1.6-12.3,4.7c-2.9,3.2-4.4,7.3-4.4,12.4c0,5.1,1.5,9.2,4.4,12.4
        c2.9,3.2,7,4.7,12.3,4.7c5.3,0,9.4-1.6,12.3-4.7c2.9-3.2,4.4-7.3,4.4-12.4c0-5.1-1.5-9.2-4.4-12.4C560.9,65,556.8,63.4,551.5,63.4
        z"
        />
        <polygon class="svg--no-background" points="716.9,75.9 739.2,75.9 728,47.6" />
        <path class="svg--no-background"
              d="M1039.1,61.3c-2.1,0-4.2,0.3-6.2,1.1c-1.7,0.7-3.2,1.7-4.6,2.9c-1.2,1.1-2.3,2.5-3,4.1
        c-0.7,1.5-1.1,3.2-1.2,4.9h27.9c0.2-3.4-1.1-6.7-3.5-9.2C1046.1,62.6,1042.7,61.2,1039.1,61.3z"
        />
        <path class="svg--no-background"
              d="M322.4,63.4c-5.3,0-9.4,1.6-12.3,4.7s-4.4,7.3-4.4,12.4c0,5.1,1.5,9.2,4.4,12.4s7,4.7,12.3,4.7
        c5.3,0,9.4-1.6,12.3-4.7c2.9-3.2,4.4-7.3,4.4-12.4c0-5.1-1.5-9.2-4.4-12.4C331.8,65,327.7,63.4,322.4,63.4z"
        />
        <path class="svg--no-background"
              d="M255,40.1c-1.8-0.8-3.7-1.3-5.7-1.5c-2-0.2-4-0.3-6-0.3h-10.4v21.9h13.6c1.8,0,3.5-0.2,5.3-0.5
        c1.6-0.3,3.2-0.9,4.6-1.8c1.4-0.8,2.5-2,3.3-3.4c0.9-1.7,1.3-3.5,1.2-5.4c0.1-2-0.5-4-1.6-5.7C258.1,42,256.6,40.9,255,40.1z"
        />
        <path class="svg--no-background"
              d="M1166.9,64.3c-5.1,0-9,1.5-11.9,4.6c-2.8,3-4.2,7-4.2,11.9c0,4.9,1.4,8.9,4.2,11.9c2.8,3,6.8,4.6,11.9,4.6
        c5.1,0,9-1.5,11.9-4.6c2.8-3,4.2-7,4.2-11.9c0-4.9-1.4-8.9-4.2-11.9C1176,65.8,1172,64.3,1166.9,64.3z"
        />
        <path class="svg--no-background"
              d="M1245.7,83.2c-2.3,0.1-4.5,0.5-6.7,1.2c-2,0.6-3.8,1.5-5.4,2.9c-1.5,1.3-2.4,3.3-2.2,5.3
        c-0.1,2.3,1.1,4.4,3.1,5.4c2,1.2,4.2,1.8,6.5,1.8c2,0,3.9-0.3,5.8-0.8c1.8-0.5,3.4-1.3,5-2.3c1.4-1,2.6-2.3,3.5-3.8
        c0.9-1.7,1.3-3.5,1.3-5.4V83h-5C1249.9,83,1248,83.1,1245.7,83.2z"
        />
        <path class="logo__text"
              d="M720.5,22L682,111.1h21.7l7.4-18.9h34.6l7.7,18.9h22.2L736.7,22H720.5z M716.9,75.9L728,47.6l11.2,28.4H716.9
        z"
        />
        <path class="logo__text"
              d="M875.5,56.1c-1.7-2.4-4-4.4-6.7-5.7c-3.3-1.5-6.8-2.2-10.4-2.1c-4-0.1-7.9,0.7-11.5,2.5
        c-3.4,2-6.2,4.9-7.9,8.4c-1.5-3.5-4.1-6.5-7.5-8.3c-3.5-1.8-7.4-2.7-11.4-2.6c-2.1,0-4.3,0.3-6.3,0.9c-1.8,0.5-3.5,1.3-5.2,2.3
        c-1.4,0.9-2.8,1.9-3.9,3.1c-1,1-1.9,2.2-2.5,3.5h-0.3v-8.3h-18.1v61.2h18.9V80.6c0-1.9,0.1-3.9,0.4-5.8c0.2-1.7,0.7-3.4,1.6-5
        c0.8-1.5,2-2.7,3.5-3.5c1.8-1,3.9-1.4,5.9-1.3c1.8-0.1,3.6,0.4,5,1.5c1.1,1,2,2.2,2.5,3.7c0.5,1.5,0.8,3,0.9,4.5
        c0.1,1.6,0.1,2.9,0.1,4v32.4h18.9V78.7c0-1.8,0.2-3.6,0.6-5.3c0.3-1.6,1-3.1,1.9-4.4c0.9-1.3,2.1-2.3,3.5-3
        c1.7-0.8,3.6-1.1,5.5-1.1c3.1,0,5.3,1,6.5,3.1c1.3,2.2,1.9,4.8,1.8,7.4v35.6h18.9V75c0-3.5-0.3-7-1.1-10.4
        C878.4,61.6,877.2,58.7,875.5,56.1z"
        />
        <path class="logo__text"
              d="M935.7,77.7c-2.4-1.3-5-2.3-7.7-3c-2.7-0.6-5.3-1.2-7.7-1.8c-2-0.4-4-1.1-5.9-1.9c-1.4-0.5-2.3-1.8-2.3-3.3
        c-0.1-1.6,0.8-3.2,2.3-3.9c1.4-0.7,3-1.1,4.7-1.1c4.3-0.1,8.3,1.8,11,5.2l11.6-11.5c-2.8-3-6.5-5.2-10.4-6.3
        c-4-1.2-8.1-1.7-12.2-1.8c-3.2,0-6.4,0.4-9.4,1.2c-3,0.7-5.7,2-8.2,3.7c-2.4,1.7-4.4,3.9-5.8,6.4c-1.5,2.9-2.3,6.1-2.2,9.3
        c0,3.9,0.8,6.9,2.3,9.3c1.5,2.3,3.5,4.1,5.9,5.4c2.4,1.3,5,2.2,7.7,2.8c2.7,0.6,5.3,1.2,7.7,1.8c2,0.4,4,1.1,5.9,2
        c1.4,0.6,2.4,2,2.3,3.6c0,1.6-1.1,3.1-2.6,3.5c-1.9,0.7-3.9,1-5.9,0.9c-2.6,0.1-5.2-0.5-7.5-1.7c-2.3-1.2-4.3-2.9-5.9-5
        l-11.5,12.7c3,3.1,6.9,5.4,11.1,6.5c4.2,1.2,8.6,1.8,13,1.8c3.3,0,6.7-0.3,9.9-0.9c3.2-0.6,6.3-1.7,9.1-3.3
        c2.7-1.5,4.9-3.6,6.6-6.2c1.8-2.9,2.7-6.3,2.6-9.8c0-3.9-0.8-6.9-2.3-9.3C940.1,80.9,938.1,79.1,935.7,77.7z"
        />
        <path class="logo__text"
              d="M980.6,31.8h-18.9v18.1h-12.1V65h12.1v29.1c-0.1,2.9,0.5,5.9,1.7,8.6c1.1,2.3,2.7,4.2,4.7,5.7
        c2.1,1.5,4.5,2.6,7.1,3.2c2.9,0.7,5.8,1,8.8,1c2.2,0,4.5-0.1,6.7-0.4c2.2-0.2,4.4-0.8,6.5-1.5V95c-1.1,0.8-2.4,1.4-3.7,1.4
        c-1.3,0.2-2.6,0.3-4,0.3c-1.7,0.1-3.3-0.2-4.8-0.8c-1.1-0.5-2.1-1.3-2.7-2.3c-0.6-1.1-1-2.3-1.1-3.6c-0.2-1.5-0.3-3.1-0.3-4.6V65
        h16.6V49.9h-16.6V31.8z"
        />
        <path class="logo__text"
              d="M1061.7,57.1c-2.5-2.8-5.6-5-9.1-6.5c-3.8-1.6-7.8-2.3-11.9-2.3c-4.5,0-9,0.7-13.3,2.3
        c-4,1.4-7.7,3.6-10.8,6.5c-3.1,2.8-5.6,6.3-7.2,10.1c-3.5,8.5-3.5,18,0,26.4c1.7,3.8,4.2,7.3,7.2,10.1c3.1,2.9,6.8,5.1,10.8,6.5
        c4.3,1.5,8.8,2.3,13.3,2.3c5,0,9.9-1.1,14.4-3.1c4.5-2,8.4-5.1,11.5-8.9l-13.2-9.7c-1.5,2.1-3.4,3.9-5.6,5.4
        c-2.4,1.4-5.1,2.2-7.9,2.1c-3.4,0.1-6.7-1-9.3-3.2c-2.6-2.2-4.3-5.3-4.9-8.6h43.8v-5.9c0.1-4.5-0.6-9-2-13.2
        C1066.3,63.6,1064.3,60.1,1061.7,57.1z M1024.2,74.3c0.1-1.7,0.5-3.3,1.2-4.9c0.7-1.5,1.7-2.9,3-4.1c1.3-1.2,2.9-2.2,4.6-2.9
        c2-0.8,4.1-1.2,6.2-1.1c3.5-0.1,7,1.3,9.4,3.8c2.4,2.4,3.7,5.7,3.5,9.2L1024.2,74.3z"
        />
        <path class="logo__text"
              d="M1119.6,48.4c-3.7-0.1-7.3,0.8-10.4,2.8c-3,2.2-5.5,5.1-7.2,8.5h-0.3v-9.8h-18.9v61.2h18.9V85.5
        c0-2.8,0.2-5.6,0.5-8.3c0.3-2.3,1-4.5,2.2-6.5c1.2-1.8,2.9-3.3,4.8-4.2c2.7-1.1,5.6-1.6,8.6-1.5c1.4,0,2.7,0.1,4.1,0.3
        c1.3,0.2,2.7,0.5,4,0.9V49c-1-0.3-2-0.4-3-0.5C1121.8,48.4,1120.7,48.4,1119.6,48.4z"
        />
        <path class="logo__text"
              d="M1181.3,56.5h-0.3c-2.1-2.9-5-5-8.4-6.2c-3.5-1.2-7.3-1.9-11-1.8c-4.1-0.1-8.1,0.9-11.7,2.7
        c-3.4,1.8-6.4,4.2-8.8,7.2c-2.4,3.1-4.3,6.6-5.5,10.4c-1.3,4-2,8.1-2,12.3c0,4.3,0.7,8.6,2.1,12.7c1.3,3.7,3.4,7.1,6.1,10
        c2.7,2.8,5.9,5.1,9.5,6.5c3.9,1.6,8.1,2.4,12.3,2.3c2.1,0,4.1-0.3,6.1-0.9c1.9-0.5,3.7-1.3,5.4-2.3c1.5-0.9,3-1.9,4.3-3.1
        c1.1-1,2.1-2.1,3-3.3h0.3v8.1h17.4V15.9h-18.9L1181.3,56.5z M1178.8,92.7c-2.8,3-6.8,4.6-11.9,4.6s-9-1.5-11.9-4.6
        c-2.8-3-4.2-7-4.2-11.9s1.4-8.9,4.2-11.9c2.8-3,6.8-4.6,11.9-4.6s9,1.5,11.9,4.6c2.8,3,4.2,7,4.2,11.9
        C1183,85.7,1181.6,89.6,1178.8,92.7z"
        />
        <path class="logo__text"
              d="M1267.2,56.6c-2.3-2.8-5.2-4.9-8.6-6.1c-4.4-1.5-9-2.2-13.7-2.1c-5,0-9.9,0.8-14.6,2.5
        c-4.6,1.6-8.8,4.1-12.3,7.4l10.1,10.3c1.9-2.2,4.3-4,6.9-5.4c2.6-1.3,5.6-2,8.5-2c3.1-0.1,6.1,1,8.5,3c2.4,2,3.7,4.9,3.6,8
        c-2.6,0-5.4,0-8.5,0.1c-3.1,0.1-6.1,0.3-9.2,0.8c-3,0.4-6,1.1-8.9,2c-2.7,0.8-5.3,2.1-7.6,3.7c-2.2,1.6-4,3.6-5.3,6
        c-1.4,2.8-2,5.8-2,8.9c-0.1,2.8,0.5,5.6,1.8,8.2c1.1,2.3,2.8,4.3,4.8,5.9c2.1,1.6,4.5,2.8,7,3.6c2.7,0.8,5.5,1.2,8.2,1.2
        c3.8,0,7.5-0.7,11-2.1c3.5-1.4,6.4-3.9,8.4-7.1h0.3v7.7h17.4V80c0.1-4.5-0.4-9.1-1.3-13.5C1271,62.9,1269.5,59.5,1267.2,56.6z
         M1256.5,87.4c0,1.9-0.4,3.8-1.3,5.4c-0.8,1.5-2,2.8-3.5,3.8c-1.5,1-3.2,1.8-5,2.3c-1.9,0.5-3.8,0.8-5.8,0.8
        c-2.3,0-4.5-0.6-6.5-1.8c-2-1-3.2-3.2-3.1-5.4c-0.1-2,0.7-4,2.2-5.3c1.6-1.3,3.4-2.3,5.4-2.9c2.2-0.6,4.4-1,6.7-1.2
        c2.3-0.1,4.2-0.2,5.8-0.2h5V87.4z"
        />
        <path class="logo__text"
              d="M1381.8,64.6c-0.6-3-1.8-5.9-3.5-8.4c-1.7-2.4-4-4.4-6.7-5.7c-3.3-1.5-6.8-2.2-10.4-2.1
        c-4-0.1-7.9,0.7-11.5,2.5c-3.4,2-6.2,4.9-7.9,8.4c-1.5-3.5-4.1-6.5-7.5-8.3c-3.5-1.8-7.4-2.7-11.4-2.6c-2.1,0-4.3,0.3-6.3,0.9
        c-1.8,0.5-3.5,1.3-5.2,2.3c-1.4,0.9-2.7,1.9-3.9,3.1c-1,1-1.8,2.2-2.5,3.5h-0.3v-8.3h-18.1v61.2h18.9V80.6c0-1.9,0.1-3.9,0.4-5.8
        c0.2-1.7,0.8-3.4,1.6-5c0.8-1.5,2-2.7,3.5-3.5c1.8-1,3.9-1.4,5.9-1.3c1.8-0.1,3.6,0.4,5,1.5c1.1,1,2,2.2,2.5,3.7
        c0.5,1.5,0.8,3,0.9,4.5c0.1,1.6,0.1,2.9,0.1,4v32.4h18.9V78.7c0-1.8,0.2-3.6,0.6-5.3c0.3-1.6,1-3.1,1.9-4.4c0.9-1.3,2.1-2.3,3.5-3
        c1.7-0.8,3.6-1.1,5.5-1.1c3.1,0,5.3,1,6.5,3.1c1.3,2.2,1.9,4.8,1.8,7.4v35.6h18.9V75C1382.9,71.5,1382.5,68,1381.8,64.6z"
        />
        <path class="logo__text"
              d="M270.7,27.6c-3.3-2.1-6.9-3.6-10.8-4.3c-4.3-0.9-8.7-1.3-13.1-1.3h-33.1v89.1h19.6V76.4h14.4
        c4.4,0,8.8-0.4,13.1-1.3c3.8-0.8,7.3-2.3,10.5-4.5c3-2.2,5.4-5.1,6.9-8.4c1.8-4.1,2.7-8.6,2.5-13.1c0-5.3-0.9-9.7-2.7-13.2
        C276.3,32.6,273.8,29.8,270.7,27.6z M259.5,54.5c-0.8,1.4-1.9,2.6-3.3,3.4c-1.4,0.8-2.9,1.4-4.6,1.8c-1.7,0.4-3.5,0.5-5.3,0.5
        h-13.6V38.3h10.4c2,0,4,0.1,6,0.3c2,0.2,3.9,0.7,5.7,1.5c1.6,0.7,3.1,1.9,4.2,3.3c1.2,1.7,1.7,3.7,1.6,5.7
        C260.8,51,260.4,52.9,259.5,54.5z"
        />
        <path class="logo__text"
              d="M346.5,57.2c-3.1-2.9-6.8-5.1-10.8-6.5c-8.6-3-18-3-26.6,0c-4,1.4-7.7,3.6-10.8,6.5
        c-3.1,2.8-5.6,6.3-7.2,10.1c-3.5,8.5-3.5,18,0,26.4c1.7,3.8,4.2,7.3,7.2,10.1c3.1,2.9,6.8,5.1,10.8,6.5c8.6,3,18,3,26.6,0
        c4-1.4,7.7-3.6,10.8-6.5c3.1-2.8,5.6-6.3,7.2-10.1c3.5-8.5,3.5-18,0-26.4C352,63.5,349.6,60.1,346.5,57.2z M334.7,93
        c-2.9,3.2-7,4.7-12.3,4.7c-5.3,0-9.4-1.6-12.3-4.7c-2.9-3.2-4.4-7.3-4.4-12.4c0-5.1,1.5-9.2,4.4-12.4c2.9-3.2,7-4.7,12.3-4.7
        c5.3,0,9.4,1.6,12.3,4.7c2.9,3.2,4.4,7.3,4.4,12.4C339.1,85.7,337.6,89.8,334.7,93z"
        />
        <path class="logo__text"
              d="M404.2,48.5c-3.7-0.1-7.3,0.8-10.5,2.8c-3,2.2-5.5,5.1-7.2,8.5h-0.3V50h-18.9v61.2h18.9V85.6
        c0-2.8,0.2-5.6,0.5-8.3c0.3-2.3,1-4.5,2.2-6.5c1.2-1.8,2.9-3.3,4.8-4.2c2.7-1.1,5.6-1.6,8.6-1.5c1.4,0,2.7,0.1,4.1,0.3
        c1.3,0.2,2.7,0.5,4,0.9V49.1c-1-0.3-2-0.4-3-0.5C406.4,48.5,405.3,48.5,404.2,48.5z"
        />
        <path class="logo__text"
              d="M450,31.9h-18.9V50h-12.1v15.1h12.1v29.1c-0.1,2.9,0.5,5.9,1.7,8.6c1.1,2.3,2.7,4.2,4.7,5.7
        c2.1,1.5,4.5,2.6,7,3.2c2.9,0.7,5.8,1,8.8,1c2.2,0,4.5-0.1,6.7-0.4c2.2-0.2,4.4-0.8,6.5-1.5V95.1c-1.1,0.8-2.4,1.4-3.7,1.4
        c-1.3,0.2-2.6,0.3-4,0.3c-1.7,0.1-3.3-0.2-4.8-0.8c-1.1-0.5-2.1-1.3-2.7-2.3c-0.6-1.1-1-2.3-1.1-3.6c-0.2-1.5-0.3-3.1-0.3-4.6
        V65.1h16.6V50H450L450,31.9z"
        />
        <path class="logo__text"
              d="M575.6,57.2c-3.1-2.9-6.8-5.1-10.8-6.5c-8.6-3-18-3-26.6,0c-4,1.4-7.7,3.6-10.8,6.5
        c-3.1,2.8-5.6,6.3-7.2,10.1c-3.5,8.5-3.5,18,0,26.4c1.7,3.8,4.2,7.3,7.2,10.1c3.1,2.9,6.8,5.1,10.8,6.5c8.6,3,18,3,26.6,0
        c4-1.4,7.7-3.6,10.8-6.5c3.1-2.8,5.6-6.3,7.2-10.1c3.5-8.5,3.5-18,0-26.4C581.2,63.5,578.7,60.1,575.6,57.2z M563.9,93
        c-2.9,3.2-7,4.7-12.3,4.7c-5.3,0-9.4-1.6-12.3-4.7c-2.9-3.2-4.4-7.3-4.4-12.4c0-5.1,1.5-9.2,4.4-12.4c2.9-3.2,7-4.7,12.3-4.7
        c5.3,0,9.4,1.6,12.3,4.7c2.9,3.2,4.4,7.3,4.4,12.4C568.2,85.7,566.8,89.8,563.9,93z"
        />
        <path class="logo__text"
              d="M627.1,14.5c-5.1,0-9.3,0.7-12.4,1.9c-2.9,1.1-5.4,2.9-7.2,5.4c-1.7,2.3-2.9,5-3.4,7.9
        c-0.6,3.1-0.9,6.3-0.9,9.5V50h-12.5v15.1h12.5v46.1H622V65.1h14V50h-14v-9.7c0-4,0.8-6.7,2.3-8c1.5-1.3,3.8-2,6.8-2
        c1.1,0,2.1,0.1,3.1,0.3c1,0.2,2,0.6,3,0.9l0.9-16c-1.8-0.4-3.6-0.7-5.4-0.9C630.9,14.6,629,14.5,627.1,14.5z"
        />
      </g>
    </g>
  </svg>
</template>

<script>

export default {
  name: 'Logo',
  props: {
    isWhite: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.logo {
  &__logo {
    fill: $color-tertiary;
    .logo--is-white & {
      fill: $white;
    }
  }
  &__text {
    fill: $color-primary;
    .logo--is-white & {
      fill: $white;
    }
  }
}
</style>
